  let keyApiOrderReceive = "https:\/\/endrock.novapower.io\/endrockapi\/v3\/app\/estimatedArrival2025\/beachriot\/all"
  document.addEventListener("DOMContentLoaded", () => {
    console.log(keyApiOrderReceive);
    const dateElement = document.getElementById("orderby-receiveby-value");
    dateElement.innerHTML = "&nbsp;";
    fetch(keyApiOrderReceive)
        .then((response) => {
            if (!response.ok) {
                throw new Error("The network response was not successful");
            }
            console.log(response);
            return response.json();
        })
        .then((data) => {
            if (data && data.data && data.data.delivery_max_date_end_at_desc) {
                const deliveryDateString = data.data.delivery_max_date_end_at_desc;
                const dateObject = new Date(deliveryDateString);
                const options = { weekday: "short", month: "short", day: "2-digit" };
                const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
                    dateObject
                );
                dateElement.textContent = `  ${formattedDate}`;
            } else {
                dateElement.textContent = "Date not available";
            }
        })
        .catch((error) => {
            console.error("There was a problem fetching the delivery date:", error);
            document.querySelector(".orderby-receiveby").classList.add("orderby-receiveby--error");
        })
        .finally(() => {
            dateElement.classList.remove("loading-skeleton");
        });
});